export const DEALER_BRANDING = 'dealerBranding';
export const FLOW_TEMPLATE = 'flow-template';
export const DEALER_ID = 'dealerId';
